import { useState } from "react"

type TOpenState = boolean
type THandler = () => void

export default function usePopup(): [TOpenState, THandler, THandler] {
  const [isOpen, setIsOpen] = useState<TOpenState>(false)
  const handleOpen: THandler = () => {
    document.getElementsByTagName("html")[0].style.overflow = "hidden"
    setIsOpen(true)
  }
  const handleClose: THandler = () => {
    document.getElementsByTagName("html")[0].style.overflow = ""
    setIsOpen(false)
  }
  return [isOpen, handleOpen, handleClose]
}
